import PropTypes from 'prop-types';
import React, {
  useCallback,
  useEffect,
  useState,
} from 'react';

import Authenticator from 'components/Authenticator';
import Card from 'components/Card';
import { Row } from 'components/Grid';
import Loading from 'components/Loading';
import Page from 'containers/Page';
import auth from 'lib/auth';
import tracker from 'lib/tracker';
import store from 'lib/store';
import useIsMobile from 'lib/useIsMobile';

const styles = {
  card: {
    maxWidth: 400,
  },
  row: { minHeight: '75vh' },
};

const SignInPage = ({ location = { params: {} }, router, viewer }) => {
  const { params: { message, redirect, state } = {} } = location;
  const [loaded, setLoaded] = useState(false);
  const mobile = useIsMobile();
  const onAuthenticated = useCallback(
    () => {
      tracker.trackGoogleAnalyticsEvent('User', 'Login');
      router.push(redirect || '/discover/events');
    },
    [
      redirect,
      router,
    ],
  );
  useEffect(
    () => {
      auth.isSignedIn()
        .then(async (isSignedIn) => {
          if (isSignedIn) {
            await store.save('skipUntilNextLogin', false);
            router.push('/discover/events');
          } else {
            setLoaded(true);
          }
        });
    },
    [router],
  );
  return (
    <Page
      title='Sign In / Sign Up'
      viewer={viewer}
    >
      {loaded
        ? (
          <Row
            centered
            style={!mobile
              ? styles.row
              : null}
          >
            <Card
              style={!mobile
                ? styles.card
                : null}
            >
              <Authenticator
                state={state}
                message={message}
                onAuthenticated={onAuthenticated}
              />
            </Card>
          </Row>
        )
        : <Loading />}
    </Page>
  );
};

SignInPage.propTypes = {
  location: PropTypes.object.isRequired,
  relay: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
};

export default SignInPage;
